import {AfterViewInit, ChangeDetectionStrategy, Component, input} from '@angular/core';
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
import {TranslatePipe} from "@ngx-translate/core";
import {NewsListComponent} from "../../../components/news/news-list/news-list.component";
import {TNewsItem} from '../../about-us/about.types';
import {RouterLink} from "@angular/router";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-home-news',
  imports: [
    SafeHtmlPipe,
    TranslatePipe,
    NewsListComponent,
    RouterLink,
    MatProgressSpinner
  ],
  templateUrl: './home-news.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeNewsComponent implements AfterViewInit {
  newsList = input<TNewsItem[]>([]);
  loading = input<boolean>(false);

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-news-section',
      }
    });

    tl.addLabel('start')
      .from('#home-news-section-title', {
        opacity: 0,
        y: 50,
        duration: 0.3,
      })
  }
}
